import WarningIcon from 'src/assets/icons/WarningIcon';

export const warningIcon = <WarningIcon width="20" height="20" />;

export const GLInfoIcon = (
  <div className="w-5 h-5">
    <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 0.375C2.895 0.375 0.375 2.895 0.375 6C0.375 9.105 2.895 11.625 6 11.625C9.105 11.625 11.625 9.105 11.625 6C11.625 2.895 9.105 0.375 6 0.375Z"
        fill="white"
      />
      <path
        d="M6 0.375C2.895 0.375 0.375 2.895 0.375 6C0.375 9.105 2.895 11.625 6 11.625C9.105 11.625 11.625 9.105 11.625 6C11.625 2.895 9.105 0.375 6 0.375ZM6 9.375C5.5875 9.375 5.25 9.0375 5.25 8.625C5.25 8.2125 5.5875 7.875 6 7.875C6.4125 7.875 6.75 8.2125 6.75 8.625C6.75 9.0375 6.4125 9.375 6 9.375ZM6.85875 3.55875L6.6075 6.56625C6.58125 6.88125 6.31875 7.125 6 7.125C5.68125 7.125 5.41875 6.88125 5.3925 6.56625L5.14125 3.55875C5.1 3.05625 5.49375 2.625 6 2.625C6.48 2.625 6.8625 3.015 6.8625 3.4875C6.8625 3.51 6.8625 3.53625 6.85875 3.55875Z"
        fill="#3FA9DB"
      />
    </svg>
  </div>
);

export const errorIcon = (
  <div className="w-5 h-5">
    <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 0.375C2.895 0.375 0.375 2.895 0.375 6C0.375 9.105 2.895 11.625 6 11.625C9.105 11.625 11.625 9.105 11.625 6C11.625 2.895 9.105 0.375 6 0.375Z"
        fill="white"
      />
      <path
        d="M6 0.375C2.895 0.375 0.375 2.895 0.375 6C0.375 9.105 2.895 11.625 6 11.625C9.105 11.625 11.625 9.105 11.625 6C11.625 2.895 9.105 0.375 6 0.375ZM6 9.375C5.5875 9.375 5.25 9.0375 5.25 8.625C5.25 8.2125 5.5875 7.875 6 7.875C6.4125 7.875 6.75 8.2125 6.75 8.625C6.75 9.0375 6.4125 9.375 6 9.375ZM6.85875 3.55875L6.6075 6.56625C6.58125 6.88125 6.31875 7.125 6 7.125C5.68125 7.125 5.41875 6.88125 5.3925 6.56625L5.14125 3.55875C5.1 3.05625 5.49375 2.625 6 2.625C6.48 2.625 6.8625 3.015 6.8625 3.4875C6.8625 3.51 6.8625 3.53625 6.85875 3.55875Z"
        fill="#D9534F"
      />
    </svg>
  </div>
);

export const informationIcon = (
  <div className="w-5 h-5  rounded-full border-[2px] border-white">
    <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g transform="scale(1, -1) translate(0, -12)">
        <path
          d="M6 0.375C2.895 0.375 0.375 2.895 0.375 6C0.375 9.105 2.895 11.625 6 11.625C9.105 11.625 11.625 9.105 11.625 6C11.625 2.895 9.105 0.375 6 0.375Z"
          fill="white"
        />
        <path
          d="M6 0.375C2.895 0.375 0.375 2.895 0.375 6C0.375 9.105 2.895 11.625 6 11.625C9.105 11.625 11.625 9.105 11.625 6C11.625 2.895 9.105 0.375 6 0.375ZM6 9.375C5.5875 9.375 5.25 9.0375 5.25 8.625C5.25 8.2125 5.5875 7.875 6 7.875C6.4125 7.875 6.75 8.2125 6.75 8.625C6.75 9.0375 6.4125 9.375 6 9.375ZM6.85875 3.55875L6.6075 6.56625C6.58125 6.88125 6.31875 7.125 6 7.125C5.68125 7.125 5.41875 6.88125 5.3925 6.56625L5.14125 3.55875C5.1 3.05625 5.49375 2.625 6 2.625C6.48 2.625 6.8625 3.015 6.8625 3.4875C6.8625 3.51 6.8625 3.53625 6.85875 3.55875Z"
          fill="#3FA9DB"
        />
      </g>
    </svg>
  </div>
);

export const iIcon = (
  <div className="w-[1.4rem] h-[1.4rem]  rounded-full border-[2px] border-white">
    <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 0.375C2.895 0.375 0.375 2.895 0.375 6C0.375 9.105 2.895 11.625 6 11.625C9.105 11.625 11.625 9.105 11.625 6C11.625 2.895 9.105 0.375 6 0.375Z"
        fill="white"
      />
      <path
        d="M6 0.375C2.895 0.375 0.375 2.895 0.375 6C0.375 9.105 2.895 11.625 6 11.625C9.105 11.625 11.625 9.105 11.625 6C11.625 2.895 9.105 0.375 6 0.375ZM6 9.375C5.5875 9.375 5.25 9.0375 5.25 8.625C5.25 8.2125 5.5875 7.875 6 7.875C6.4125 7.875 6.75 8.2125 6.75 8.625C6.75 9.0375 6.4125 9.375 6 9.375ZM6.85875 3.55875L6.6075 6.56625C6.58125 6.88125 6.31875 7.125 6 7.125C5.68125 7.125 5.41875 6.88125 5.3925 6.56625L5.14125 3.55875C5.1 3.05625 5.49375 2.625 6 2.625C6.48 2.625 6.8625 3.015 6.8625 3.4875C6.8625 3.51 6.8625 3.53625 6.85875 3.55875Z"
        fill="#3FA9DB"
      />
    </svg>
  </div>
);

export const whiteIcon = (
  <div className="w-5 h-5">
    <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 0.375C2.895 0.375 0.375 2.895 0.375 6C0.375 9.105 2.895 11.625 6 11.625C9.105 11.625 11.625 9.105 11.625 6C11.625 2.895 9.105 0.375 6 0.375ZM6 9.375C5.5875 9.375 5.25 9.0375 5.25 8.625C5.25 8.2125 5.5875 7.875 6 7.875C6.4125 7.875 6.75 8.2125 6.75 8.625C6.75 9.0375 6.4125 9.375 6 9.375ZM6.85875 3.55875L6.6075 6.56625C6.58125 6.88125 6.31875 7.125 6 7.125C5.68125 7.125 5.41875 6.88125 5.3925 6.56625L5.14125 3.55875C5.1 3.05625 5.49375 2.625 6 2.625C6.48 2.625 6.8625 3.015 6.8625 3.4875C6.8625 3.51 6.8625 3.53625 6.85875 3.55875Z"
        fill="white"
      />
    </svg>
  </div>
);

export const getBgColor = (errors: string[], warnings?: string[], infos?: string[]) =>
  errors?.length
    ? 'bg-error bg-opacity-25'
    : warnings?.length
    ? 'bg-warning bg-opacity-25'
    : infos?.length
    ? 'bg-[#abd7ed]'
    : '';

export const getBgColorString = (errors: string[], warnings?: string[], infos?: string[]) =>
  errors?.length
    ? '#D9534F40'
    : warnings?.length
    ? '#FFF85D40'
    : infos?.length
    ? '#abd7ed'
    : 'transparent';

export const getIcon = (errors: string[], warnings?: string[], infos?: string[]) =>
  errors?.length ? errorIcon : warnings?.length ? warningIcon : infos?.length ? iIcon : '';
